import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'signup_auth_by_contract_epargn.title',
  },
  subTitle: {
    id: 'signup_auth_by_contract_epargn.sub_title',
  },
  contratEpargn: {
    id: 'signup_auth_by_contract_epargn.type_assurance',
  },
  souscripteur: {
    id: 'signup_auth_by_contract_epargn.souscripteur',
  },
  dateEffet: {
    id: 'signup_auth_by_contract_epargn.date_effet',
  },
  numContrat: {
    id: 'signup_auth_by_contract_epargn.numero_contrat',
  },

  suivant: {
    id: 'signup_auth_button.next',
  },
  precedent: {
    id: 'signup_auth_button.previous',
  },
});
